import { BRAND_NAME, TRADEMARK_SYMBOL } from '../../constants/brand';

const BrandName = () => (
  <>
    {BRAND_NAME}
    <sup className="ml-[0.06em] text-[0.45em] leading-none top-[-0.15em]">
      {TRADEMARK_SYMBOL}
    </sup>
  </>
);

export default BrandName;
